import { Navigate, useRoutes } from "react-router-dom";
import Login from "../features/auth/pages/Login";
import UserAccessLayout from "../features/common-pages/UserAccessLayout";
import Register from "../features/auth/pages/Register";
import ForgotPassword from "../features/auth/pages/ForgotPassword";
import ProductLayout from "../features/common-pages/ProductLayout";
import ProductSelection from "../features/product-selection/ProductSelection";
import NotFound from "../features/common-pages/NotFound";
import Error from "../features/common-pages/Error";
import PrivacyAndPolicy from "../features/legal/PrivacyAndPolicy";
import TermsAndConditions from "../features/legal/TermsAndConditions";
import Logout from "../features/auth/pages/Logout";
import InvitePage from "../features/invites/InvitePage";
import ChangePassword from "../features/auth/pages/ChangePassword";

interface AppRouterProps {
  showSnackbar: boolean;
}

const AppRouter: React.FC<AppRouterProps> = ({ showSnackbar }) => {

  const routes = [
    {
      path: "not-found",
      element: <UserAccessLayout />,
      children: [
        {
          index: true,
          element: <NotFound />,
        },
      ],
    },
    {
      path: "/",
      element: <Navigate to="/account/login" replace />,
    },
    {
      path: "/account",
      element: <UserAccessLayout />,
      children: [
        {
          index: true, // when the path is exactly /account
          element: <Navigate to="/account/login" replace />,
        },
        {
          path: "login",
          element: <Login />,
        },
        {
          path: "register",
          element: <Register />,
        },
        {
          path: "forgot-password",
          element: <ForgotPassword />,
        },
        {
          path: "change-password",
          element: <ChangePassword />,
        },
      ],
    },
    {
      path: "/invite",
      element: <UserAccessLayout />,
      children: [
        {
          path: ":guid",
          element: <InvitePage />,
        },
      ],
    },
    {
      path: "",
      element: <ProductLayout showSnackbar={showSnackbar} />,
      children: [
        {
          path: "/product-selection",
          element: <ProductSelection />,
          index: true,
        },
        {
          path: "/privacy-policy",
          element: <PrivacyAndPolicy />,
        },
        {
          path: "/terms-conditions",
          element: <TermsAndConditions />,
        },
        {
          path: "/account/logout",
          element: <Logout />,
        },
        {
          path: "/edit-profile",
          element: <h1>Edit Profile</h1>,
        },
        {
          path: "/error",
          element: <Error />,
        },
      ],
    },
    { path: "*", element: <Navigate to="/not-found" /> },
  ];
  const element = useRoutes(routes);

  return element;
};

export default AppRouter;
